import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
	return (
		<div className="flex h-screen bg-gray-50 relative">
			{/* Sidebar */}
			<Sidebar />

			{/* Main Section */}
			<div className="flex-1 flex flex-col">
				<Header />

				<main className="flex-1 overflow-y-auto px-6 pb-6">
					<Outlet />
				</main>

				<Footer />
			</div>
		</div>
	);
};

export default DashboardLayout;

// import React from "react";
// import Sidebar from "../Sidebar/Sidebar";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
// import { Outlet } from "react-router-dom";
// // import Snowfall from "react-snowfall";

// const DashboardLayout = () => {
// 	return (
// 		<div className="flex h-screen bg-gray-50">
// 			{/* <Snowfall color="#82C3D9" /> */}
// 			{/* Sidebar */}
// 			<Sidebar />

// 			{/* Main Section */}
// 			<div className="flex-1 flex flex-col">
// 				{/* Header */}
// 				<Header />

// 				{/* Main content area */}
// 				<main className="flex-1 overflow-y-auto px-6 pb-6">
// 					<Outlet />
// 				</main>

// 				<Footer />
// 			</div>
// 		</div>
// 	);
// };

// export default DashboardLayout;
